export default __webpack_public_path__ + "static/thumbnail-adf67eb5a1b1ceead92da0e1cc8eeb87.jpg";